import React from 'react';
import { connect } from 'react-redux';
import classes from './TagsTree.module.scss';
import iconDelete from 'PMDB/assets/images/png_icons/cancel_icon_black.png';
import * as actions from 'store/actions/index';

import Input from 'Flow2/components/UI/Input/Input';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';

const MIN_INPUT_LENGTH = 1;

const SingleTag = (props) => {
	return(
		<div className={[props.class, 'pointer'].join(' ')} onClick={() => {props.handleTagClick(props)}}>
			{props.tag.description}
		</div>
	);
}

const SelectedTag = (props) => {
    let title = props.tag.levels ? (props.tag.levels.join('->') + '->' + props.tag.description) : props.tag.description;
    
    return (
        <div key={'seld_' + props.tag.id} className={[classes.selectedTags, 'flex_container', 'relative'].join(' ')} >
            <span className="text_ellipsis" title={title}>{props.tag.description}</span>
            <img alt="" className="pointer" onClick={() => {props.handleRemoveTag(props)}} src={iconDelete} />
        </div>
    );
}

class TagsTree extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			selectedTags: [],
			foundTags:{tags:[], modelsIds:[]},
            value: "",
			json: (props.data === 'tags' && this.props.apiTags) || this.props.apiModels,
			lang: props.lang.toUpperCase(),
			defaultLanguage: this.props.defaultLanguage || "EN",
            preSelectedTags: props.preSelectedTags,
            open: false
		};
        
        if(props.preSelectedTags) {
            this.state.selectedTags = TagsTree.initSelectedTags(props, this.state);
        }
	};
    
    handleClearInput = id => {
        this.setState({foundTags:{tags:[], modelsIds:[]}, value:""});
    };

	onKeyUp = (evt) => {
		let foundTags = {};
		foundTags.tags = [];
		foundTags.modelsIds = []; // Here come the id's of the first level
		
		let inputValue = evt.target.value;
		
		if (inputValue.length >= MIN_INPUT_LENGTH) {
			for(let levels1 of this.state.json.Levels) {
                if(levels1.Levels && levels1.Levels.length) {
                    for(let levels2 of levels1.Levels) {
                        if (levels2.Levels) {
                            for(let tag of levels2.Levels) {
                                let language = this.state.lang || this.props.language;
                                if(!tag[language]) {
                                    language = this.state.defaultLanguage;
                                }
                                
                                // check HideLevel == because value could be int or string
                                if (tag[language].toLowerCase().indexOf(evt.target.value.toLowerCase()) !== -1 && (tag.HideLevel === 'undefined' || parseInt(tag.HideLevel) === 0)) {
                                    foundTags.tags.push({'id':tag.ID, 'description':tag[language], levels:[levels1[language], levels2[language]]});
                                }
                            }
                        } else {
                            let language = this.state.lang || this.props.language;
                            if(!levels2[language]) {
                                language = this.state.defaultLanguage;
                            }
                            
                            // check HideLevel == because value could be int or string
                            if (levels2[language].toLowerCase().indexOf(evt.target.value.toLowerCase()) !== -1 && (levels2.HideLevel === 'undefined' || levels2.HideLevel == 0)) {
                                if (foundTags.modelsIds.indexOf(levels1.ID) === -1) {
                                    foundTags.modelsIds.push(levels1.ID);
                                    foundTags.tags.push({'id':levels1.ID, 'description':levels1[language]});
                                }
                                
                                foundTags.tags.push({'id':levels2.ID, 'description':levels2[language], levels:[levels1[language]]});
                            } else {
                                if (levels1[language].toLowerCase().indexOf(evt.target.value.toLowerCase()) !== -1 && (levels1.HideLevel === 'undefined' || levels1.HideLevel == 0)) {
                                    if (foundTags.modelsIds.indexOf(levels1.ID) === -1) {
                                        foundTags.modelsIds.push(levels1.ID);
                                        foundTags.tags.push({'id':levels1.ID, 'description':levels1[language]});
                                    }
                                }
                            }
                        }
                    }
                } else {
                    let language = this.state.lang || this.props.language;
                    if(!levels1[language]) {
                        language = this.state.defaultLanguage;
                    }
                    
                    if (levels1[language].toLowerCase().indexOf(evt.target.value.toLowerCase()) !== -1 && (levels1.HideLevel === 'undefined' || levels1.HideLevel == 0)) {
                        if (foundTags.modelsIds.indexOf(levels1.ID) === -1) {
                            foundTags.modelsIds.push(levels1.ID);
                            foundTags.tags.push({'id':levels1.ID, 'description':levels1[language]});
                        }
                    }
                }
			}
		}

		this.setState({foundTags:foundTags, value:evt.target.value, open:true});
	};
    
    onOpen = () => {
		let foundTags = {};
		foundTags.tags = [];
		foundTags.modelsIds = []; // Here come the id's of the first level

		if(!this.state.open) {
            
            for(let levels1 of this.state.json.Levels) {
                if(levels1.Levels && levels1.Levels.length) {
                    for(let levels2 of levels1.Levels) {
                        if (levels2.Levels) {
                            for(let tag of levels2.Levels) {
                                let language = this.state.lang || this.props.language;
                                if(!tag[language]) {
                                    language = this.state.defaultLanguage;
                                }
                                
                                // check HideLevel == because value could be int or string
                                if (tag.HideLevel === 'undefined' || (parseInt(tag.HideLevel) === 0)) {
                                    foundTags.tags.push({'id':tag.ID, 'description':tag[language], levels:[levels1[language], levels2[language]]});
                                }
                            }
                        } else {
                            let language = this.state.lang || this.props.language;
                            if(!levels2[language]) {
                                language = this.state.defaultLanguage;
                            }
                            
                            // check HideLevel == because value could be int or string
                            if (levels2.HideLevel === 'undefined' || (levels2.HideLevel == 0)) {
                                if (foundTags.modelsIds.indexOf(levels1.ID) === -1) {
                                    foundTags.modelsIds.push(levels1.ID);
                                    foundTags.tags.push({'id':levels1.ID, 'description':levels1[language]});
                                }
                                
                                foundTags.tags.push({'id':levels2.ID, 'description':levels2[language], levels:[levels1[language]]});
                            } else {
                                if (levels1.HideLevel === 'undefined' || (levels1.HideLevel == 0)) {
                                    if (foundTags.modelsIds.indexOf(levels1.ID) === -1) {
                                        foundTags.modelsIds.push(levels1.ID);
                                        foundTags.tags.push({'id':levels1.ID, 'description':levels1[language]});
                                    }
                                }
                            }
                        }
                    }
                } else {
                    let language = this.state.lang || this.props.language;
                    if(!levels1[language]) {
                        language = this.state.defaultLanguage;
                    }
                    
                    if (levels1.HideLevel === 'undefined' || (levels1.HideLevel == 0)) {
                        if (foundTags.modelsIds.indexOf(levels1.ID) === -1) {
                            foundTags.modelsIds.push(levels1.ID);
                            foundTags.tags.push({'id':levels1.ID, 'description':levels1[language]});
                        }
                    }
                }
            }
            
            foundTags.tags.sort(function(a, b){
                if(a.description.toUpperCase() < b.description.toUpperCase()) { return -1; }
                if(a.description.toUpperCase() > b.description.toUpperCase()) { return 1; }
                return 0;
            })
        }

		this.setState({foundTags:foundTags, open:!this.state.open});
	};
    
    static initSelectedTags(props, state) {
        const selectedTags = [];
        const modelIds = []; // Here come the id's of the first level
        
        for(let levels1 of state.json.Levels) {
            if(levels1.Levels && levels1.Levels.length) {
                for(let levels2 of levels1.Levels) {
                    if (levels2.Levels) {
                        for(let tag of levels2.Levels) {
                            if (props.preSelectedTags.includes(tag.ID+"")) {
                                selectedTags.push({'id':tag.ID, 'description':tag[state.lang || props.language], levels:[levels1[state.lang || props.language], levels2[state.lang || props.language]]});
                            }
                        }
                    } else {
                        if (props.preSelectedTags.includes(levels2.ID+"")) {
                            selectedTags.push({'id':levels2.ID, 'description':levels2[state.lang || props.language], levels:[levels1[state.lang || props.language]]});
                        } else {
                            if (props.preSelectedTags.includes(levels1.ID+"")) {
                                if (modelIds.indexOf(levels1.ID) === -1) {
                                    modelIds.push(levels1.ID);
                                    selectedTags.push({'id':levels1.ID, 'description':levels1[state.lang || props.language]});
                                }
                            }
                        }
                    }
                }
            } else {
                if (props.preSelectedTags.includes(levels1.ID+"")) {
                    if (modelIds.indexOf(levels1.ID) === -1) {
                        modelIds.push(levels1.ID);
                        selectedTags.push({'id':levels1.ID, 'description':levels1[state.lang || props.language]});
                    }
                }
            }
        }
        
        return selectedTags;
    }

	handleTagClick = (props) => {
		let selectedTags = this.state.selectedTags.slice();
		let tagExists = false;

		for(let tag of selectedTags) {
			if (tag.id === props.tag.id) {
				tagExists = true;
			}
		}

		if (!tagExists) {
			selectedTags.push(props.tag);

             this.props.addHandler({
                    [this.props.field]: TagsTree.getSelectedTags(selectedTags, 'description'), 
                    [this.props.refField]: TagsTree.getSelectedTags(selectedTags, 'id') 
                }, 
                props.tag,
                this.props.refField
            );
		}
		

		this.setState({selectedTags: selectedTags});
	};

	handleRemoveTag = (props) => {
		let selectedTags = this.state.selectedTags.slice();

		selectedTags = selectedTags.filter(tag => {
			return tag.id !== props.tag.id;
		});
		
        this.props.removeHandler({
                [this.props.field]: TagsTree.getSelectedTags(selectedTags, 'description'), 
                [this.props.refField]: TagsTree.getSelectedTags(selectedTags, 'id') 
            }, 
            props.tag,
            this.props.refField
        );

		this.setState({selectedTags: selectedTags});
	};

	render = () => {
        
        if(this.props.readonly) {
            return this.state.selectedTags.map(tag => {
                return (<span key={'seld_' + tag.id}>{tag.description + ";"}&nbsp;</span>);
            });
        }
        
		return (
			<div className="">
                <FlexRow className="relative">
                    <Input
                        value={this.state.value}
                        elementConfig={{type: 'text', id:'tagsInput'}}
                        changed={this.onKeyUp} />
                    <img alt="" className={[classes.clear, 'pointer'].join(' ')} onClick={() => {this.handleClearInput('tagsInput')}} src={iconDelete} />
                    <span className={[classes.open, classes[this.state.open]].join(' ')} onClick={() => {this.onOpen()}}/>
                </FlexRow>
                
				<FlexRow className={classes.wrap}>
					{
						this.state.selectedTags.map(tag => {
							return (
								<SelectedTag key={tag.id} tag={tag} handleRemoveTag={this.handleRemoveTag} />
							)
						})
					}
					
				</FlexRow>
				<div className={classes.SuggestionsContainer}>
				<FlexColumn className={classes.Suggestions}>
					{
						this.state.foundTags.tags.map(tag => {
							return(
                                <SingleTag class={(this.state.foundTags.modelsIds.indexOf(tag.id) !== -1 && classes.tagGroup) || classes.tag} key={tag.id} handleTagClick={this.handleTagClick} tag={tag} />
                            )
						})
					}
				</FlexColumn>
				</div>
			</div>
		)
	}
    
    static getDerivedStateFromProps(nextProps, prevState) {
        let selectedTags = prevState.selectedTags || [];
        if(nextProps && prevState && nextProps.preSelectedTags) {
            selectedTags = TagsTree.initSelectedTags(nextProps, prevState);
        }
        
        return {
            selectedTags: selectedTags,
            preSelectedTags: nextProps.preSelectedTags,
            lang: nextProps.lang.toUpperCase(),
            value: nextProps.readonly ? "" : prevState.value,
            foundTags: nextProps.readonly ? {tags:[], modelsIds:[]} : prevState.foundTags
        }
    }
	
	static getSelectedTags(data, props) {
        data = data || "";
        if ((data!==undefined) && (data!=="") && (data.length>0)){
            let selectedTags = [];
            data.map((item)=>{selectedTags.push(item[props]);});
            return selectedTags.join(';');
        }
        return "";
    }
}

const mapStateToProps = ( state ) => {
	return {
		apiTags: state.ui.apiTags,
		apiModels: state.ui.apiModels,
		language: state.ui.language.toUpperCase()
	};
}

const mapDispatchToProps = ( dispatch ) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TagsTree);

